import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { ProductSelectionDialogComponent } from '../product-selection-dialog/product-selection-dialog.component';
import { v4 as uuidv4 } from 'uuid';

import * as Chartist from 'chartist';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

import { interval } from 'rxjs';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { formatDate } from "@angular/common";

import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ReponseWebService } from '../datastruct/Meloyi.module';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { DetailCommandeComponent } from '../detail-commande/detail-commande.component';

import { ExcelService } from '../excel.service';

import { GestockService } from '../services/gestock.service';
import { DashboardserviceService } from '../services/dashboardservice.service';

import { saveAs } from 'file-saver';



interface ArticleStock {
  id: string;
  nom: string;
  qteDisponible: number;
  qteAtransferer: number;
}


@Component({
  selector: 'app-stock-transfer',
  templateUrl: './stock-transfer.component.html',
  styleUrls: ['./stock-transfer.component.css']
})
export class StockTransferComponent  implements OnInit {


  searchTerm: string = '';
  page: number = 1;

    products = [] ; 

    productYeupp = [] ;

  itemsPerPage = 1;
  currentPage = 1;



  depots = [];
  allPoints = []; 
  sourceDepot = '';
  destinationDepot = '';


  articles: ArticleStock[] = [];

  stores = ['Boutique A', 'Boutique B', 'Boutique C'];
  selectedStore: string | null = null;
  selectedProducts: { name: string; quantity: number; entryPrice: number; salePrice: number }[] = [];

  selectedCategories: string[] = [];

  qteAtransferer : any ;


  constructor( @Inject(MAT_DIALOG_DATA) public data: any, private dashboardService: DashboardserviceService, 
    private excelService: ExcelService, private httpClient: HttpClient,
    public dialog: MatDialog,  private configServer: GestockService,
     private _adapter: DateAdapter<any>, public dialogRef: MatDialogRef<StockTransferComponent>,
      @Inject(MAT_DATE_LOCALE) private _locale: string) {

    this.depots = data.element.depotyi ;
    this.allPoints = data.element.pointyi ;
    this.products = data.element.articleyi ;
  }

  ngOnInit(): void {
    // Exemple d’articles :: ben article:{ id: '1', nom: 'Produit A', qteDisponible: 100, qteAtransferer: 0 }
    this.articles = [];
  }



  getStockDispoCiDepotBiPourKii(article){
    for (var i = 0; i < article.quantity.stocksParDepot.length; i++) {
      if(article.quantity.stocksParDepot[i].nomDepot==this.sourceDepot)
        return article.quantity.stocksParDepot[i].qteEnStock ;
    }
    return 0;
  }


  //get filteredProducts() {
  get filteredProducts() {
    return this.products.filter(product => {
      const matchesSearch = this.searchTerm === '' || product.name.toLowerCase().includes(this.searchTerm.toLowerCase());
      const matchesCategory = this.selectedCategories.length === 0 || this.selectedCategories.includes(product.category);
      return matchesSearch && matchesCategory;
    });
  }


  get paginatedProducts() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.filteredProducts.slice(start, end);
  }



  openProductDialog() {
    const dialogRef = this.dialog.open(ProductSelectionDialogComponent, { width: '500px' });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.selectedProducts = result;
      }
    });
  }

  hasArticlesSelected(): boolean {
    return this.articles.some(a => a.qteAtransferer > 0);
  }


  getNombreArticlesSelectionnes(): number {
    return this.articles.filter(a => a.qteAtransferer > 0).length;
  }


  getArticlesSelectionnes(): any {
    return this.articles.filter(a => a.qteAtransferer > 0);
  }

  onSearchChange(event){
    this.qteAtransferer = 0 ;    
  }


  ajouterArticle(article: any, quantiteATransferer: number): void {
    console.log('À ajouter :', article);

    const qteStockDepot = this.getStockDispoCiDepotBiPourKii(article);

    // Vérifie si l'article est déjà dans la liste
    const dejaAjoute = this.articles.some(a => a.id === article.id);

    if (dejaAjoute) {
      alert("Cet article est déjà dans le transfert.");
      return;
    }

    if (quantiteATransferer > 0 && quantiteATransferer <= qteStockDepot) {
      article.qteAtransferer = quantiteATransferer;

      const benArticle = article ;

      article.qteDisponible = qteStockDepot ;

      this.articles.push(benArticle);
    } else {
      alert("Quantité invalide !");
    }

    this.qteAtransferer = 0;
  }


  validerTransfert() {
    const payload = {
      sourceDepot: this.sourceDepot,
      destinationDepot: this.destinationDepot,
      articles: this.articles
        .filter(a => a.qteAtransferer > 0)
        .map(a => ({ id: a.id, nom: a.nom, qte: a.qteAtransferer })),
    };

    console.log('Transfert à envoyer :', payload);
    // Appel API ici
  }



  close(){
    this.dialogRef.close();
  }


  sendTransfer() {
    if (!this.selectedStore || this.selectedProducts.length === 0) return;

    const transfer: any = {
      id: uuidv4(),
      senderStore: 'Boutique actuelle',
      receiverStore: this.selectedStore,
      products: this.selectedProducts.map(p => ({
        ...p,
        entryPrice: p.salePrice // Prix d'entrée = prix de vente du vendeur
      })),
      status: 'pending'
    };

    //this.stockTransferService.addTransfer(transfer);
    this.selectedProducts = [];
  }
}
